// extracted by mini-css-extract-plugin
module.exports = {"stickyFooter":"jut__StickyFooter__stickyFooter","fullWidth":"jut__StickyFooter__fullWidth"};